import React, {useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useHistory, useLocation} from 'react-router-dom';

import Utility from '../../../../util/utilityfunctions';
import {currentResource} from '../../../../util/utils';
import {groupRiskAssessmentTabId} from '../../../../util/uiconstants';

import selectLastRefreshedFromSpecificTab from '../../../../reducers/GroupRiskAsssesment/selectLastRefreshedFromSpecificTab';

import ActivityFeed from '../ActivityFeed';
import Reconciliations from '../Reconciliations';

import TemplateWithSidebar from '../../../Templates/TemplateWithSidebar';
import TabNavigation from '../../../CoreWrappers/TabNavigation';
import ShowMoreLess from '../../../CoreWrappers/ShowMoreLess';
import RightDashboardLoader from '../../../Common/Loaders/RightDashboardLoader';
import Sidebar from '../../../Common/Sidebar';
import LabelAndDate from '../../../Common/LabelAndDate';
import StyledGroupRiskAssessment from '../StyledGroupRiskAssessment';

const TableView = () => {
	const [activeTab, setActiveTab] = useState(null);

	const labels = currentResource.groupRiskAssessmentLabels;
	const orgChart = useSelector(({dashboardContext}) => dashboardContext?.orgChart);
	const lastRefreshedObj = selectLastRefreshedFromSpecificTab(activeTab?.id ?? null);

	const history = useHistory();
	const location = useLocation();

	const tabs = [
		{
			id: groupRiskAssessmentTabId.reconciliations,
			label: labels.reconciliations,
			hash: '#reconciliations',
			visible: true,
			View: Reconciliations
		},
		{
			id: groupRiskAssessmentTabId.activityFeed,
			label: labels.activityFeed,
			hash: '#activityFeed',
			visible: true,
			View: ActivityFeed
		}
	];

	useEffect(() => {
		handleHashAtLoad();
	}, []);

	const handleSetTab = (newTab) => {
		history.replace(`${location.search}${newTab.hash}`);
		setActiveTab(newTab);
	};

	const handleHashAtLoad = () => {
		const hash = location.hash;
		if (!!hash) {
			const hashTab = tabs.find(({hash: hashTag}) => hashTag.toLowerCase() === hash.toLowerCase());
			setActiveTab(hashTab ? hashTab : tabs[0]);
		} else {
			handleSetTab(tabs[0]);
		}
	};

	const renderLastRefreshed = () => {
		const props = {
			className: 'last-refreshed',
			label: lastRefreshedObj?.lastRefreshedLabel,
			date: lastRefreshedObj?.lastRefreshedDate,
			body2: true,
			light: true,
			color: 'var(--neutrals-700)'
		};
		return <LabelAndDate {...props} />;
	};

	const renderTabs = () => {
		const props = {
			tabs,
			activeTab,
			setTab: handleSetTab,
			size: 'md',
			customSideContent: renderLastRefreshed
		};

		return <TabNavigation {...props} />;
	};

	const renderSidebar = () => <Sidebar moduleLabel={labels.groupRiskAssessment} />;

	const renderLoader = () => <RightDashboardLoader />;

	const renderInstructional = () => {
		const props = {
			text: Utility.createRichTextElement(labels.groupRiskAssessmentInstructional),
			initialEllipsed: false,
			numLines: 3,
			fontSize: 'body1'
		};

		return <ShowMoreLess {...props} />;
	};

	const renderContent = () => (
		<StyledGroupRiskAssessment>
			{renderInstructional()}
			{renderTabs()}
			{activeTab && <activeTab.View />}
		</StyledGroupRiskAssessment>
	);

	return (
		<TemplateWithSidebar renderSidebar={renderSidebar}>
			{!orgChart ? renderLoader() : renderContent()}
		</TemplateWithSidebar>
	);
};

export default TableView;
